import { useNavigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../store/useAuthStore'
import { useI18n } from '../i18n'
import { AuthArea } from './AuthArea'

interface Props {
  children: React.ReactNode
}

export function Layout({ children }: Props) {
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useI18n()
  const user = useAuthStore((s) => s.user)

  const isBuilder = location.pathname === '/create'

  return (
    <div className="flex min-h-screen flex-col">
      <header className="flex items-center justify-between border-b border-surface-lighter px-6 py-4">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-white font-bold text-sm select-none">
            QR
          </div>
          <span className="text-lg font-bold text-text">QR Tool</span>
        </div>
        <nav className="flex items-center gap-4">
          {user && !isBuilder && (
            <button
              onClick={() => navigate('/create')}
              className="text-sm text-text-muted hover:text-primary transition-colors"
            >
              {t('nav.builder')}
            </button>
          )}
          {user && (
            <button
              onClick={() => navigate('/my-codes')}
              className="text-sm text-text-muted hover:text-primary transition-colors"
            >
              {t('myCodes.title')}
            </button>
          )}
          <AuthArea />
        </nav>
      </header>

      <main className="flex-1">
        {children}
      </main>

      <footer className="border-t border-surface-lighter px-6 py-6 text-center text-sm text-text-muted">
        <div className="mb-2 flex justify-center gap-6">
          <button onClick={() => navigate('/impressum')} className="hover:text-primary transition-colors">
            {t('footer.impressum')}
          </button>
          <button onClick={() => navigate('/kontakt')} className="hover:text-primary transition-colors">
            {t('footer.kontakt')}
          </button>
          <button onClick={() => navigate('/datenschutz')} className="hover:text-primary transition-colors">
            {t('footer.datenschutz')}
          </button>
        </div>
        <p className="text-xs opacity-50">&copy; {new Date().getFullYear()} QR Tool</p>
      </footer>
    </div>
  )
}
